<template>
  <div
    class="request-table-toolbar d-flex align-center justify-space-between flex-wrap"
    data-testid="request-table-toolbar"
  >
    <div
      class="request-table-toolbar__count d-flex align-center"
      data-testid="request-table-toolbar__count"
    >
      <span class="request-table-toolbar__count-label">Records</span>
      <span
        class="request-table-toolbar__count-badge"
        data-testid="request-table-toolbar__count-badge"
      >
        {{ count }}
      </span>
    </div>

    <div class="request-table-toolbar__right d-flex align-center">
      <div class="request-table-toolbar__chips d-flex align-center">
        <PipelineStatusChips
          :loading="loading"
          :metadata="metadata"
          :chips="chips"
          :status-variant-map="statusVariantMap"
          :selected-tab-stage="selectedTabStage"
          :active-summary="activeSummary"
          :show-when-empty="true"
          @select-stage="$emit('select-stage', $event)"
        />
      </div>

      <div class="request-table-toolbar__divider" aria-hidden="true" />

      <div class="request-table-toolbar__actions d-flex align-center">
        <v-btn
          v-if="hasActiveTableFilter"
          text
          class="mr-2 data-table-action__clear-filter-btn"
          data-testid="request-table-toolbar__clear-filter-btn"
          @click="$emit('clear-filter')"
        >
          <span>Clear Filter</span>
        </v-btn>
        <CustomizeColumnMenu
          v-model="customizeMenuOpen"
          :headers="headers"
          color="caccounting"
          :show-save-button="false"
          :show-apply-button="true"
          data-testid-prefix="request-table-toolbar"
          @apply="$emit('apply-columns', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import './RequestTableToolbar.scss';
import { CustomizeColumnMenu, PipelineStatusChips } from '../../../../../components';
import {
  INFORMATION_MANAGER_STATUS_CHIPS,
} from '../../../../../utils/listConstants';
import {
  INFORMATION_MANAGER_STAGE_STATUS_VARIANT,
} from '../../../../../utils/constants';

export default {
  name: 'RequestTableToolbar',
  components: {
    CustomizeColumnMenu,
    PipelineStatusChips,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    metadata: {
      type: Object,
      default: () => ({}),
    },
    selectedTabStage: {
      type: [Number, String],
      default: null,
    },
    activeSummary: {
      type: Object,
      default: () => ({}),
    },
    count: {
      type: Number,
      default: 0,
    },
    hasActiveTableFilter: {
      type: Boolean,
      default: false,
    },
    headers: {
      type: Array,
      default: () => [],
    },
    chips: {
      type: Array,
      default: () => INFORMATION_MANAGER_STATUS_CHIPS,
    },
    statusVariantMap: {
      type: Object,
      default: () => INFORMATION_MANAGER_STAGE_STATUS_VARIANT,
    },
  },
  data() {
    return {
      customizeMenuOpen: false,
    };
  },
};
</script>
